import * as React from 'react';
import { SvgIcon, SvgIconBaseProps } from '../components/SvgIcon/SvgIcon';

export function TagIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path d="M 12.171875 3 L 2.5859375 12.585938 C 2.2079375 12.963938 2 13.466 2 14 C 2 14.534 2.2079375 15.036062 2.5859375 15.414062 L 8.5859375 21.414062 C 8.9639375 21.792063 9.466 22 10 22 C 10.534 22 11.036062 21.792063 11.414062 21.414062 L 21 11.828125 L 21 3 L 12.171875 3 z M 13 5 L 19 5 L 19 11 L 10 20 L 4 14 L 13 5 z M 16 7 A 1 1 0 0 0 15 8 A 1 1 0 0 0 16 9 A 1 1 0 0 0 17 8 A 1 1 0 0 0 16 7 z" />
        </SvgIcon>
    );
}
